module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-2-4389755f9f549ed0e25ea6915fcf868f.webp";